import Main from "../../components/login/main";

const Login = () => {
  return (
    <>
      <Main />
    </>
  );
};
export default Login;
